import React, { useRef, useState } from 'react'
import {
  Avatar,
  Button,
  Card,
  Divider,
  Icon,
  Input,
  Popconfirm,
  Table
} from 'antd'
import { compose, graphql, withApollo } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import Highlighter from 'react-highlight-words'
import BrandForm from './BrandForm'
import UpdateStatus from './UpdateStatus'
import {
  createBrand,
  deleteBrand,
  fetchBrandList,
  updateBrand,
  updateBrandStatus
} from '../../modules/brand'
import _ from 'lodash'
import { fetchProductFeatureList } from '../../modules/productFeature'
import { getMaterials } from '../../modules/material'

const Brand = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [visibleStatus, setVisibleStatus] = useState(false)
  const [searchText, setSearchText] = useState('')

  const { brandList, isLoading } = useSelector(
    (state) => ({
      brandList: state.brand.brandList,
      isLoading: state.brand.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchBrandList())
      await dispatch(fetchProductFeatureList())
      await dispatch(getMaterials())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const columns = [
    {
      title: 'ID',
      key: 'id',
      dataIndex: 'id'
    },
    {
      title: 'Avatar',
      dataIndex: 'logo',
      key: 'logo',
      render: (text, record) =>
        text ? <Avatar src={text} size={48} /> : <span>-</span>
    },
    {
      title: 'Brand Name',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          {row && row.cover && (
            <img
              src={row.cover.url}
              width={64}
              height={64}
              style={{ marginRight: 10, objectFit: 'cover' }}
              alt="Product"
            />
          )}
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'Sponsor',
      key: 'sponsorTag',
      dataIndex: 'sponsorTag',
      render: (text, record) => <span>{text ? 'ใช่' : 'ไม่'}</span>
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (text, record) => (
        <span
          style={{ cursor: 'pointer', color: 'blue' }}
          onClick={(e) => updateStatus(e, record)}>
          {text}
        </span>
      )
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const updateStatus = (e, record) => {
    e.preventDefault()
    setVisibleStatus(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await dispatch(fetchBrandList())
    await setVisible(false)
  }

  const onCloseModalStatus = async () => {
    await dispatch(fetchBrandList())
    await setVisibleStatus(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateBrand(data))
    } else {
      await dispatch(createBrand(data))
    }

    await dispatch(fetchBrandList())
    await setVisible(false)
    await setFormData({})
  }

  const onOkStatus = async (data) => {
    await dispatch(updateBrandStatus(data))
    await dispatch(fetchBrandList())
    await setVisibleStatus(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deleteBrand(id))
    await dispatch(fetchBrandList())
  }

  const refetchData = async () => {}

  // async function onShowSizeChange(current, pageSize) {
  //   options.size = pageSize
  //   setOptions(options)
  // }
  //
  // async function onChange(page) {
  //   options.page = page - 1
  //   setOptions(options)
  // }
  //
  // const reset = async (e) => {
  //   e.preventDefault()
  //   options.keyword = ''
  //
  //   await form.resetFields()
  // }

  return (
    <div>
      {!visible ? (
        <Card
          title="Brand"
          extra={
            <div>
              <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
                New Brand
              </Button>
              <Button size="small" icon="reload" onClick={() => refetchData()}>
                Reload
              </Button>
            </div>
          }>
          {/* <Form layout="inline" onSubmit={handleSubmit}> */}
          {/*  <Form.Item label="keyword"> */}
          {/*    {form.getFieldDecorator('keyword')(<Input placeholder="บาร์โค้ด,ชื่อสินค้า,ยี่ห้อสินค้า"/>)} */}
          {/*  </Form.Item> */}
          {/*  <Form.Item> */}
          {/*    <Button type="primary" htmlType="submit"> */}
          {/*      ค้นหา */}
          {/*    </Button> */}
          {/*  </Form.Item> */}
          {/*  <Form.Item> */}
          {/*    <Button onClick={(e) => reset(e)}> */}
          {/*      รีเซ็ต */}
          {/*    </Button> */}
          {/*  </Form.Item> */}
          {/* </Form> */}
          <br />
          <Table
            bordered
            loading={isLoading}
            dataSource={brandList}
            columns={columns}
            rowKey={(record) => {
              return record.id
            }}
            // pagination={{
            //   current: barcodeProductObj.pageable.pageNumber + 1,
            //   pageSize: barcodeProductObj.size,
            //   pageSizeOptions: ['10', '20', '50', '100'],
            //   showSizeChanger: true,
            //   onShowSizeChange: onShowSizeChange,
            //   onChange: onChange,
            //   total: barcodeProductObj.totalElements
            // }}
          />
          <UpdateStatus
            visible={visibleStatus}
            onOk={onOkStatus}
            onCancel={onCloseModalStatus}
            formData={formData}
          />
        </Card>
      ) : (
        <BrandForm
          visible={visible}
          formData={formData}
          onOk={onOk}
          onCancel={onCloseModal}
        />
      )}
    </div>
  )
}

export default compose(withApollo)(Brand)
